export default "__VITE_ASSET__DDs8uwZR__"